import { useApi } from '@/api'

export const useTeamResource = () => {
  const api = useApi()
  const teamOf = (organizationId: string) => api.api.v1.organizations({ organizationId }).team
  const invitationsOf = (organizationId: string) => teamOf(organizationId).invitations
  const memberOf = (organizationId: string, membershipId: string) => teamOf(organizationId).members({ membershipId })

  type InviteBody = Parameters<ReturnType<typeof invitationsOf>['post']>[0]
  type RolesBody = Parameters<ReturnType<typeof memberOf>['roles']['patch']>[0]
  type BrandsBody = Parameters<ReturnType<typeof memberOf>['brands']['patch']>[0]

  return {
    getTeam: (organizationId: string) => teamOf(organizationId).get(),
    setTeamInvitation: (organizationId: string, body: InviteBody) => invitationsOf(organizationId).post(body),
    delTeamInvitation: (organizationId: string, invitationId: string) => invitationsOf(organizationId)({ invitationId }).delete(undefined),
    setTeamMemberRoles: (organizationId: string, membershipId: string, body: RolesBody) =>
      memberOf(organizationId, membershipId).roles.patch(body),
    setTeamMemberBrands: (organizationId: string, membershipId: string, body: BrandsBody) =>
      memberOf(organizationId, membershipId).brands.patch(body),
    delTeamMember: (organizationId: string, membershipId: string) => memberOf(organizationId, membershipId).delete(undefined)
  }
}
